import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";

export const orderListRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ORDER_LIST,
    path: "/account/order-list",
    component: () => import("@/pages/history-order/order-item.vue"),
    meta: {
      requireAuth: true
    }
  };
};

export const orderDetailRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ORDER_DETAIL,
    path: "/account/order/:id",
    component: () => import("@/pages/history-order/order-detail.vue"),
    meta: {
      requireAuth: true
    }
  };
};
